// import HeaderSearchInputIcon from "@gaiaherbs/Icons/HeaderSearchInputIcon";
import { slideshowStyles } from "@insite/content-library/Widgets/Basic/Slideshow";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";

slideshowStyles.prevArrowWrapper = mergeToNew(slideshowStyles.prevArrowWrapper, {
    css: css`
        position: absolute;
        z-index: 1;
        top: 50%;
        margin-top: -20px;
        ${({ theme }) => {
            return breakpointMediaQueries(
                theme,
                [
                    css`
                        left: 1rem;
                    `,
                    null,
                    null,
                    css`
                        left: 5rem;
                    `,
                ],
                "min",
            );
        }}
        [class^=ButtonWrapper] {
            background: ${getColor("primary.contrast")};
            width: 40px;
            height: 40px;
            border-radius: 50%;
            > span {
                display: flex;
                align-items: center;
                justify-content: center;
                top: 0;
                width: 100%;
                svg {
                    stroke: ${getColor("text.link")};
                    height: 24px;
                    width: 24px;
                }
            }
            &:hover {
              background: #FFFFFF;
            }
        }
    `,
});

slideshowStyles.nextArrowWrapper = mergeToNew(slideshowStyles.nextArrowWrapper, {
    css: css`
        position: absolute;
        z-index: 1;
        top: 50%;
        margin-top: -20px;
        right: 0;
        ${({ theme }) => {
            return breakpointMediaQueries(
                theme,
                [
                    css`
                        right: 1rem;
                    `,
                    null,
                    null,
                    css`
                        right: 5rem;
                    `,
                ],
                "min",
            );
        }}
        [class^=ButtonWrapper] {
            background: #FFFFFF;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            > span {
                display: flex;
                align-items: center;
                justify-content: center;
                top: 0;
                width: 100%;
                svg {
                    stroke: ${getColor("text.link")};
                    height: 24px;
                    width: 24px;
                }
            }
            &:hover {
              background: #FFFFFF;
            }
        }
    `,
});
